module.exports = __webpack_public_path__ + "img/zsjm-7.74b70498.webp";